import LoginPage from "../views/LoginPage.vue";
const routes = [
  {
    path: "/",
    name: "Login",
    component: LoginPage,
    // http://attendance.amritsarhaveli.in/#/?authtoken=YOUR_TOKEN_HERE
  },
  {
    path: "/privacy-policy",
    name: "PrivacyPolicy",
    component: () => import("../views/PrivacyPolicy.vue"),
  },
  {
    path: "/attendance",
    name: "Attendance",
    component: () => import("../views/Transaction/AttendancePage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/registerface",
    name: "RegisterFace",
    component: () => import("../views/Transaction/RegisterFace.vue"),
    meta: { requiresAuth: true },
  },
];

export default routes;
